import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import {
  Avatar,
  Box,
  Button,
  IconButton,
  styled,
  Typography,
} from "@mui/material";
import avr1 from "../images/avr1.png";
import avr2 from "../images/avr2.png";
import avr3 from "../images/avr3.png";
import avr4 from "../images/avr4.png";
import avr5 from "../images/avr5.png";
import avr6 from "../images/avr6.png";
import avr7 from "../images/avr7.png";
import avr8 from "../images/avr8.png";
import avr9 from "../images/avr9.png";
import avr10 from "../images/avr10.png";
import axios from "axios";
import { API_URL } from "../components/Constant";
import cr1 from "../images/cr1.png";
import cr2 from "../images/cr2.png";
import cr3 from "../images/cr3.png";
import cr4 from "../images/cr4.png";
import cr5 from "../images/cr5.png";
import cr6 from "../images/cr6.png";
import cr7 from "../images/cr7.png";
import cr8 from "../images/cr8.png";
import cr9 from "../images/cr9.png";
import cr10 from "../images/cr10.png";
import refer from "../images/refer.png";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SnowingEffect from "../components/Snowpopup";
import { Link } from "react-router-dom";
import ReferralSection from "./ReferAFreind";
import GameLevelProgress from "./GameLevel";
import snowflake from "../images/snowflake.svg";
import FloatingSocialIcons from "./SocialMedia";
import Colors from "../components/Colors";
import SliderRapidRiddle from "../components/sliderRapidRiddle";
import Footer from "../components/Footer";
import BackToBenchGameLevel from "../components/BacktoBenchGameLevel";

function AllGame() {
  const [creators, setCreators] = useState([]);
  const [creatorDetails, setCreatorDetails] = useState([]);
  const [uniqueGameIds, setUniqueGameIds] = useState([]);
  const [isCreator, setIsCreator] = useState(false);
  const [creatorId, setCreatorId] = useState(null);
  const [playerScore, setPlayerScore] = useState(null);
  const [backtobenchScore, setbacktobenchScore] = useState(null);
  const [playedGames, setPlayedGames] = useState([]);
  const [isRefer, setIsRefer] = useState(false);
  const [isPoint, setIsPoint] = useState(true);
  const [playerScoreCount, setPlayerScoreCount] = useState(null);
  const avatarMap = {
    1: avr1,
    2: avr2,
    3: avr3,
    4: avr4,
    5: avr5,
    6: avr6,
    7: avr7,
    8: avr8,
    9: avr9,
    0: avr10,
  };
  const creatorMap = {
    1: cr1,
    2: cr2,
    3: cr3,
    4: cr4,
    5: cr5,
    6: cr6,
    7: cr7,
    8: cr8,
    9: cr9,
    0: cr10,
  };

  function formatPublishingTime(dateString) {
    const date = new Date(dateString);
    const today = new Date();

    // Check if the date is today
    if (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    ) {
      return (
        <span
          style={{ fontSize: "24px", fontFamily: "Boogaloo", color: "#000" }}
        >
          🦋Today's Game!🦋
        </span>
      );
    }

    // Format the date to 'DD MMM YYYY' (e.g., 31 JAN 2025)
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return new Intl.DateTimeFormat("en-US", options).format(date).toUpperCase();
  }

  const isToday = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  useEffect(() => {
    const fetchGameData = async () => {
      console.log(localStorage.getItem("selectedCreator"));
      // console.log( localStorage.getItem('selectedCat'))
      try {
        const response = await axios.post(
          `${API_URL}/select_creator_all_game`,
          {
            creatorId: localStorage.getItem("selectedCreator"),
            status: localStorage.getItem("selectedCat"),
          },
        );
        //  console.log('select_creator_all_game',response.data)
        setCreatorDetails(response.data.result);

        const Ids = response.data.reduce((acc, item) => {
          // Check if the game_id and theme combination already exists in the accumulator
          const existingEntry = acc.find(
            (entry) =>
              entry.game_id === item.game_id && entry.theme === item.theme,
          );

          // If the combination doesn't exist, add it to the accumulator with publishing_time
          if (!existingEntry) {
            acc.push({
              game_id: item.game_id,
              theme: item.theme,
              publishing_time: item.publishing_time, // Include publishing_time
            });
          }

          return acc;
        }, []);

        setUniqueGameIds(Ids);
        //  console.log('Unique Game IDs In call:', uniqueGameIds);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchGameData();
    const intervalId = setInterval(fetchGameData, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchGameScoreCountData = async () => {
      try {
        const response = await axios.get(`${API_URL}/prize_winners`);
        setPlayerScoreCount(response.data);
        //console.log('prize_winners',response.data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchGameScoreCountData();
    const intervalId = setInterval(fetchGameScoreCountData, 1000);

    return () => clearInterval(intervalId);
  }, []);

  // const launchingSoon = creators.filter(creator => creator.game_status === 'Launching Soon');
  // const launchedGames = creators.filter(creator => creator.game_status === 'Launched Games');

  const launchingSoon = creators.filter(
    (creator) => creator.category === "Tiny Thinkers",
  );
  const launchedGames = creators.filter(
    (creator) => creator.category === "Master Minds",
  );

  const uniqueLaunchingSoon = Array.from(
    new Map(
      launchingSoon.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );
  const uniqueLaunchedGames = Array.from(
    new Map(
      launchedGames.map((creator) => [creator.creator_id, creator]),
    ).values(),
  );

  // Split creators into groups of 5 for display
  const chunkedLaunchingSoon = [];
  const chunkedLaunchedGames = [];

  let chunkSizeLaunchingSoon = 5; // Default chunk size for desktop
  let chunkSizeLaunchedGames = 5; // Default chunk size for desktop

  // Check if the screen width is small (mobile)
  if (window.innerWidth <= 568) {
    // Adjust this value based on your breakpoint
    chunkSizeLaunchingSoon = 2; // Chunk size for mobile
    chunkSizeLaunchedGames = 2; // Chunk size for mobile
  }

  for (let i = 0; i < uniqueLaunchingSoon.length; i += chunkSizeLaunchingSoon) {
    chunkedLaunchingSoon.push(
      uniqueLaunchingSoon.slice(i, i + chunkSizeLaunchingSoon),
    );
  }

  for (let i = 0; i < uniqueLaunchedGames.length; i += chunkSizeLaunchedGames) {
    chunkedLaunchedGames.push(
      uniqueLaunchedGames.slice(i, i + chunkSizeLaunchedGames),
    );
  }

  // Fetch details for a specific creator
  const handleCreatorClick = async (creatorIdValue, status) => {
    //  console.log('status',status)
    //   console.log('creatorId',creatorIdValue)
    localStorage.setItem("SelectedId", creatorIdValue);
    setIsCreator(true);
    setCreatorId(creatorIdValue);
    if (
      !localStorage.getItem("PlayerTocken") &&
      !localStorage.getItem("BackToBenchTocken") &&
      !localStorage.getItem("TimelessTiesTocken")
    ) {
      window.location.href = "/player-signin";
    } else {
      const response = await axios.post(`${API_URL}/select_creator_all_game`, {
        creatorId: creatorIdValue,
        status: status,
      });
      // console.log('select_creator_all_game',response.data)
      setCreatorDetails(response.data.result);

      const Ids = response.data.reduce((acc, item) => {
        // Check if the game_id and theme combination already exists in the accumulator
        const existingEntry = acc.find(
          (entry) =>
            entry.game_id === item.game_id && entry.theme === item.theme,
        );

        // If the combination doesn't exist, add it to the accumulator with publishing_time
        if (!existingEntry) {
          acc.push({
            game_id: item.game_id,
            theme: item.theme,
            publishing_time: item.publishing_time, // Include publishing_time
          });
        }

        return acc;
      }, []);

      setUniqueGameIds(Ids);
      // console.log('Unique Game IDs In call:', uniqueGameIds);
    }
  };

  const handleGameClick = async (gameId, publishingTime) => {
    localStorage.removeItem("RapidGame");
    const nowUTC = new Date();

    // Convert the publishing time to a UTC Date object
    const gameDateUTC = new Date(publishingTime);

    // Log both UTC times for debugging
    //console.log('Game Date UTC:', gameDateUTC.toISOString());
    //console.log('Now UTC:', nowUTC.toISOString());

    // Compare the dates directly in UTC
    const isEligible = nowUTC >= gameDateUTC;

    // Log the eligibility result
    //console.log('Is Eligible:', isEligible);

    if (isEligible) {
      const playerToken =
        localStorage.getItem("PlayerTocken") ||
        localStorage.getItem("BackToBenchTocken") ||
        localStorage.getItem("TimelessTiesTocken");
      //console.log(playerToken)
      try {
        const response = await axios.post(`${API_URL}/player_details`, {
          creatorId: localStorage.getItem("SelectedId"),
          gameId: gameId,
          PlayerTocken: playerToken,
        });
        //  console.log('player_details',response.data)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    localStorage.setItem("gameId", gameId);
    localStorage.removeItem("PointReduce");
    window.location.href = "/play-game";
  };

  useEffect(() => {
    if (
      localStorage.getItem("PlayerTocken") &&
      !localStorage.getItem("BackToBenchTocken") &&
      !localStorage.getItem("TimelessTiesTocken")
    ) {
      const fetchGameScoreData = async () => {
        try {
          const response = await axios.post(`${API_URL}/player_score`, {
            PlayerTocken: localStorage.getItem("PlayerTocken"),
          });
          setPlayerScore(response.data.totalScore);
          //console.log('creator id',localStorage.getItem('SelectedId'))
          // console.log('player score',response.data.result)
          const clickId = localStorage.getItem("SelectedId");
          const gameData = response.data.result;
          //  const filteredGames = gameData.filter((game) => game.creator_id === clickId);
          const filteredGames = gameData.rows.filter(
            (game) => game.creator_id === Number(clickId),
          );
          setPlayedGames(response.data.result.rows);
          // console.log('filteredGames',response.data.result.rows)
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchGameScoreData();
      const intervalId = setInterval(fetchGameScoreData, 1000);

      return () => clearInterval(intervalId);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("BackToBenchTocken")) {
      const fetchBackToBenchScoreData = async () => {
        try {
          // console.log(localStorage.getItem('BackToBenchTocken'))
          const response = await axios.post(
            `${API_URL}/player_back_to_bench_score`,
            {
              PlayerTocken: localStorage.getItem("BackToBenchTocken"),
            },
          );
          const score =
            response.data.totalScore !== null ? response.data.totalScore : 0;
          setbacktobenchScore(score);
          console.log("player score", response.data.totalScore);
          const clickId = localStorage.getItem("SelectedId");
          const gameData = response.data.result;
          const filteredGames = gameData.rows.filter(
            (game) => game.creator_id === Number(clickId),
          );
          setPlayedGames(response.data.result.rows);
          //  console.log('filteredGames',response.data.result.rows)
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchBackToBenchScoreData();
      const intervalId = setInterval(fetchBackToBenchScoreData, 1000);

      return () => clearInterval(intervalId);
    }
  }, []);

  const handleReferClick = async (gameId) => {
    setIsRefer(true);
  };

  const LEVELS = [
    { points: 100, color: "#dfb724" },
    { points: 300, color: "#e25a44" },
    { points: 600, color: "#c41876" },
    { points: 1000, color: "#16a550" },
  ];

  const getLevelAchieved = (points) => {
    if (points >= 1000) return LEVELS[3]; // Brown Snow
    if (points >= 600) return LEVELS[2]; // Purple Snow
    if (points >= 300) return LEVELS[1]; // Green Snow
    if (points >= 100) return LEVELS[0]; // Orange Snow
    return null;
  };

  const achievedLevel = getLevelAchieved(playerScore);

  const colors = ["#27b6ca", "#78c815", "#a14c5d", "#ffac0e"];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "8px",
        overflow: "hidden",
        background: Colors.bgColor,
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Box sx={{ width: "100%", zIndex: 101, position: "relative" }}>
        <Header />
      </Box>

      {localStorage.getItem("PlayerTocken") && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: { md: "240px", xs: "200px" },
            maxWidth: { xs: "92%", md: "92%" },
            justifyContent: "center",
            alignItems: "center",
            background: Colors.Tidesbg,
            borderRadius: "8px",
            overflow: "hidden",
            marginTop: { xs: "5%", md: "2.5%" },
            borderColor: "#EACABB",
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: { xs: "20px", md: "32px" },
              color: "#000",
              textAlign: "center",
              fontFamily: "Boogaloo",
            }}
          >
            Hello, {localStorage.getItem("PlayerName")}
          </Typography>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: { xs: "20px", md: "20px" },
              color: "#000",
              textAlign: "center",
              fontFamily: "Boogaloo",
            }}
          >
            You have achieved {playerScore} points
          </Typography>

          <GameLevelProgress points={playerScore}></GameLevelProgress>
        </Box>
      )}

      {localStorage.getItem("BackToBenchTocken") && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: { md: "160px", xs: "100px" },
            maxWidth: { xs: "92%", md: "92%" },
            justifyContent: "center",
            alignItems: "center",
            background: Colors.Tidesbg,
            borderRadius: "8px",
            overflow: "hidden",

            marginTop: { xs: "5%", md: "2.5%" },
            borderColor: "#EACABB",
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: { xs: "20px", md: "20px" },
              color: "#000",
              textAlign: "center",
              fontFamily: "Boogaloo",
            }}
          >
            You have achieved {backtobenchScore} points
          </Typography>

          <BackToBenchGameLevel
            points={backtobenchScore}
          ></BackToBenchGameLevel>
        </Box>
      )}

      <SliderRapidRiddle />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          width: "100%",
          maxWidth: "100%",
          marginTop: "5%",
          paddingBottom: "5%",
          height: "100%",
          background: Colors.AllgameBg,
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <div>
          <Typography
            sx={{
              padding: "8px",
              paddingTop: "5%",
              fontSize: "36px",
              fontFamily: "Boogaloo",
              color: "#000",
              fontWeight: 600,
              textAlign: "center",
              width: "100%",
            }}
          >
            All Games
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: { xs: "16px", md: "0px" },
              marginTop: "32px",
              marginBottom: "32px",
              width: "100%",
              minWidth: "90vw",
            }}
          >
            {(() => {
              const now = new Date();

              // Ensure only valid games are considered
              const validGames = uniqueGameIds.filter(
                (game) => game && game.publishing_time,
              );

              // Sort games chronologically
              validGames.sort(
                (a, b) =>
                  new Date(a.publishing_time) - new Date(b.publishing_time),
              );

              // Categorize games
              const todayGames = [];
              const pastGames = [];
              const futureGames = [];
              validGames.forEach((game) => {
                const gameDate = new Date(game.publishing_time);
                if (gameDate.toDateString() === now.toDateString()) {
                  todayGames.push(game);
                } else if (gameDate < now) {
                  pastGames.push(game);
                } else {
                  futureGames.push(game);
                }
              });

              // Select games based on priority
              let selectedGames = [];

              // Add today's game (only one)
              if (todayGames.length > 0) {
                selectedGames.push(todayGames[0]);
              }

              // Add past games (max 2, most recent first)
              selectedGames = [
                ...selectedGames,
                ...pastGames.slice(-2).reverse(),
              ];

              // Add future game (only 1, closest date)
              if (futureGames.length > 0) {
                selectedGames.push(futureGames[0]);
              }

              return selectedGames.map((game, index) => {
                const isToday =
                  new Date(game.publishing_time).toDateString() ===
                  now.toDateString();

                return (
                  <Box
                    key={game.game_id}
                    sx={{
                      display: "flex",
                      width: { xs: "100%", md: "300px" },
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: { md: "row", xs: "column" },
                    }}
                  >
                    <Box
                      onClick={() =>
                        handleGameClick(game.game_id, game.publishing_time)
                      }
                      sx={{
                        width: { md: "300px", xs: "85% !important" },
                        justifyContent: "left",
                        alignItems: "left",
                        height: "160px",
                        background: Colors.gameboxbg,
                        //borderRadius: "24px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        overflow: "hidden",
                        cursor: "pointer",
                        textAlign: "center",
                        borderRadius: "32px 0px ",
                        //  border: `4px solid ${isToday ?  colors[0] : colors[index % colors.length]}`,
                        border: `4px solid #fff`,
                        position: "relative",
                        transition: "transform 0.3s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.05)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          // background: isToday ? colors[0] : colors[index % colors.length],
                          background: Colors.gamedatebg,
                          display: "flex",
                          marginTop: "24px",
                          padding: "12px",
                          maxWidth: "80%",
                          height: "20px",
                          color: "#fff",
                          border: "2px solid",
                          fontWeight: "bold",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "0px ",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#000",
                            fontWeight: "bold",
                          }}
                        >
                          {formatPublishingTime(game.publishing_time)}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          borderRadius: "8px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "100%",
                          justifyContent: "center",
                          paddingTop: "6%",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "#fff",
                            lineHeight: "20px",
                          }}
                        >
                          {game.game_id}
                        </Typography>

                        <Typography
                          sx={{
                            fontSize: "16px",
                            color: "#eff89d",
                            fontWeight: 600,
                            textAlign: "right",
                            paddingRight: "20%",
                            width: "100%",
                            lineHeight: "22px",
                            marginTop: "8px",
                          }}
                        >
                          {/* {playedGames.some(
    (games) =>
      games.game_id.normalize("NFC") === game.game_id.normalize("NFC")
  )
    ? "Played"
    : ""} */}
                          {playedGames.some(
                            (games) =>
                              games?.game_id &&
                              game?.game_id &&
                              games.game_id.normalize("NFC") ===
                                game.game_id.normalize("NFC"),
                          )
                            ? "Played"
                            : ""}
                        </Typography>

                        {/* {isToday && (
                <Box
                  sx={{
                    position: "absolute",  display:'flex',justifyContent:'center',
                    top: "30px", 
                    width: '70%',
                    alignItems: 'center',
                    backgroundColor: Colors.Tidesfont,
                    color: '#FFF',
                    padding: "6px 16px",
                    borderRadius: "12px",
                    fontWeight: "bold",
                    fontSize: "14px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
               <span style={{ fontSize: "20px" }}>👑 </span> Today's Game! 
                  

                </Box>
              )} */}
                      </Box>
                    </Box>
                  </Box>
                );
              });
            })()}
          </Box>
        </div>
      </Box>

      <Footer></Footer>

      {isRefer && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: "1000",
          }}
        >
          <Box
            sx={{
              width: { md: "25%", sm: "35%", xs: "75%" },
              background: "#F1F3FC",
              borderRadius: "8px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "24px",
              border: "3px solid white",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
              }}
            >
              <IconButton
                onClick={() => {
                  setIsRefer(false);
                }}
                sx={{
                  color: "#6b6b6b",
                  "&:hover": {
                    color: "#000000",
                  },
                }}
              >
                <CloseOutlinedIcon />
              </IconButton>
            </Box>

            {isPoint && <ReferralSection></ReferralSection>}
            {!isPoint && (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <Typography
                  sx={{
                    color: "#202f75",
                    fontSize: "20px",
                    textAlign: "center",
                    fontWeight: "600",
                  }}
                >
                  Oops! It looks like you don’t have enough points to refer a
                  friend right now. 😊
                </Typography>
                <Typography
                  sx={{
                    color: "#202f75",
                    fontSize: "18px",
                    textAlign: "center",
                    fontWeight: "400",
                  }}
                >
                  Don’t worry! You can earn more points by playing the game.
                  Once you’ve earned enough points, you’ll be able to share the
                  SNOWORD Puzzle with your friends!
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default AllGame;
